import type { PublicLimitType, PublicSessionStatus } from '@pulsepoint/shared';
import { keepPreviousData, useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { get, post } from './client';
import { sessionsSearch } from './sessions';

export interface GuestRow {
  id: string;
  status: PublicSessionStatus;
  createdAt: string;
  limitType: PublicLimitType;
  limitValue: number;
  holdCents: number;
  energyWh: number | null;
  liveEnergyWh: number;
  energyCents: number | null;
  idleCents: number | null;
  finalCents: number | null;
  refundedCents: number;
  receiptNumber: string | null;
  hasEmail: boolean;
  paymentMethod: string | null;
  message: string | null;
  capturedAt: string | null;
  startedAt: string | null;
  stoppedAt: string | null;
  chargerId: string;
  chargerName: string;
  bay: string | null;
  siteName: string | null;
  organisationName: string | null;
  organisationSiteCount: number;
}

export interface GuestPage {
  rows: GuestRow[];
  count: number;
  paidCents: number;
  refundedCents: number;
  energyWh: number;
  open: number;
  page: number;
  pageSize: number;
}

export const payToChargeKey = ['pay-to-charge'] as const;

export const useGuestSessions = (q: { from?: string; to?: string; status?: PublicSessionStatus; page: number; pageSize: number }) =>
  useQuery({ queryKey: [...payToChargeKey, q], queryFn: () => get<GuestPage>(`/pay-to-charge?${sessionsSearch(q as never)}`), placeholderData: keepPreviousData });

export const useRefund = () => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ id, amountCents }: { id: string; amountCents?: number }) => post<{ refundedCents: number }>(`/pay-to-charge/${id}/refund`, { amountCents }),
    onSuccess: () => void qc.invalidateQueries({ queryKey: payToChargeKey }),
  });
};
